import { gql } from 'graphql-tag';

export const GET_SUPPLIERS = gql`
  query GetSuppliers($pagination: PaginationInput, $filter: SupplierFilterInput, $sort: SupplierSortInput) {
    suppliers(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        name
        street
        zip
        city
        country
        accountId
        contacts {
          id
          firstName
          lastName
          email
          phone
          company
        }
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_SUPPLIER = gql`
  query GetSupplier($id: ID!) {
    supplier(id: $id) {
      id
      name
      street
      zip
      city
      country
      accountId
      contacts {
        id
        firstName
        lastName
        email
        phone
        company
      }
      createdAt
      updatedAt
    }
  }
`;
